var exports = {
  "j": "x31de4314--e63e7b--cont",
  "K": "x31de4314--e63e7b--icon",
};

module.exports = exports;
